const isResidential = state => state.customerType ? (state.customerType === 'resi' ? 1 : 0) : null;
const noEmail = state => state.mail === 'noemail@mega.be';
const isTestAchat = state => state.agentCustomId === 'AG000132'; //ER-710.
const allowBXResi = state => state.agentAllowBxlResi || state.campaign == 'StayFlex24'; // ER-1212 + IS-7422.
const restrictedPostalCodes = state => state.agentRestrictedPostalCodes;

const hasSomePersonalDetails = (state) => {
  const data = [
    state.firstName,
    state.lastName,
    state.birthDate,
    state.mail,
    state.phone.number,
    state.coholderFirstName,
    state.coholderLastName
  ];
  return data.some(value => value != null && Boolean(value))
}
export default {
  isResidential,
  hasSomePersonalDetails,
  noEmail,
  isTestAchat,
  allowBXResi,
  restrictedPostalCodes
};



// WEBPACK FOOTER //
// ./src/store/modules/subscription/getters.js